import { GameAppController } from "@lib/js-slingo-fruttiboost-core/dist/game/controller/GameAppController";
import { GameController } from "@lib/js-slingo-fruttiboost-core/dist/game/controller/GameController";
import { GameDialogController } from "@lib/js-slingo-fruttiboost-core/dist/game/controller/GameDialogController";
import { GameReelController } from "@lib/js-slingo-fruttiboost-core/dist/game/controller/GameReelController";
import { GameScatterPickController } from "@lib/js-slingo-fruttiboost-core/dist/game/controller/GameScatterPickController";
import { GameScatterSoundController } from "@lib/js-slingo-fruttiboost-core/dist/game/controller/GameScatterSoundController";
import { GameSoundController } from "@lib/js-slingo-fruttiboost-core/dist/game/controller/GameSoundController";
import { GameMessageBarData } from "@lib/js-slingo-fruttiboost-core/dist/game/model/data/GameMessageBarData";
import { GameModel } from "@lib/js-slingo-fruttiboost-core/dist/game/model/GameModel";
import { FeatureCameraRig } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/camera/FeatureCameraRig";
import { MainCameraRig } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/camera/MainCameraRig";
import { GameAvailableWinDisplay } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameAvailableWinDisplay";
import { GameBackground } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameBackground";
import { GameBigWin } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameBigWin";
import { GameControlPanel } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameControlPanel";
import { GameFeatureNotepad } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameFeatureNotepad";
import { GameFireworkBurst } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameFireworkBurst";
import { GameFreeSpinsOverlay } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameFreeSpinsOverlay";
import { GameFullHouse } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameFullHouse";
import { GameLoaderDialog } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameLoaderDialog";
import { GameMessageBar } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameMessageBar";
import { GameMiniPayTable } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameMiniPayTable";
import { GameReel } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameReel";
import { GameReels } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameReels";
import { GameReelWildParticles } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameReelWildParticles";
import { GameScatterPickBackground } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameScatterPickBackground";
import { GameScatterPickCoconut } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameScatterPickCoconut";
import { GameScatterWin } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameScatterWin";
import { GameScatterWinNote } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameScatterWinNote";
import { GameSlingoParticles } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameSlingoParticles";
import { GameSpinsRemaining } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameSpinsRemaining";
import { GameStakeSelector } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameStakeSelector";
import { GameSummary } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameSummary";
import { GameSummaryCell } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameSummaryCell";
import { GameTest } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameTest";
import { GameTicket } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameTicket";
import { GameTicketSymbol } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameTicketSymbol";
import { GameTopBar } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameTopBar";
import { GameTotalWinCounter } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameTotalWinCounter";
import { GameWinDisplay } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameWinDisplay";
import { GameWinLine } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameWinLine";
import { GameWinLineCelebration } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameWinLineCelebration";
import { GameWinLineNote } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/GameWinLineNote";
import { Main } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/Main";
import { GamePayTable } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/display/PayTable/GamePayTable";
import { GameDialogManager } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/manager/GameDialogManager";
import { GameFireworkBurstProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameFireworkBurstProperties";
import { GameReelProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameReelProperties";
import { GameScatterWinNoteProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameScatterWinNoteProperties";
import { GameTicketSymbolProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameTicketSymbolProperties";
import { GameWinLineNoteProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameWinLineNoteProperties";
import { Game } from "@lib/js-slingo-fruttiboost-core/dist/game/view/Game";
import { PayTableManager } from "@lib/titan2-slingo/dist/game/controller/PayTableManager";
import { ArcadeWheel } from "@lib/titan2-slingo/dist/game/view/abstract/display/ArcadeWheel";
import { Navigation } from "@lib/titan2-slingo/dist/game/view/abstract/display/Navigation";
import { Options } from "@lib/titan2-slingo/dist/game/view/abstract/display/Options";
import { SlingoAnimationSpine } from "@lib/titan2-slingo/dist/game/view/abstract/display/SlingoAnimation";
import { ResponsibleGamingOptionType } from "@lib/titan2/dist/api/common/model/enum/ResponsibleGamingOptionType";
import { AppData } from "@lib/titan2/dist/game/AppData";
import { OrientationController } from "@lib/titan2/dist/game/controller/OrientationController";
import { SettingsController } from "@lib/titan2/dist/game/controller/SettingsController";
import { GameConfig } from "@lib/titan2/dist/game/model/data/GameConfig";
import { OrientationType } from "@lib/titan2/dist/game/renderer/constant/RendererConstants";
import { Viewport } from "@lib/titan2/dist/game/renderer/properties/Viewport";
import { DemoPlay } from "@lib/titan2/dist/game/view/display/DemoPlay";
import { DetailedGameHistory } from "@lib/titan2/dist/game/view/display/DetailedGameHistory";
import { Preloader } from "@lib/titan2/dist/game/view/display/Preloader";
import { SGDSignposting } from "@lib/titan2/dist/game/view/display/SGDSignposting";
import { DetailedGameHistoryPropertiesLandscape, DetailedGameHistoryPropertiesPortrait } from "@lib/titan2/dist/game/view/properties/AbstractDetailedGameHistoryProperties";
import { AbstractFreeRoundsInfoBannerProperties, FreeRoundsInfoBannerLocation } from "@lib/titan2/dist/game/view/properties/AbstractFreeRoundsInfoBannerProperties";
import { SGDSignpostingLandscapeProperties, SGDSignpostingPortraitProperties } from "@lib/titan2/dist/game/view/properties/SGDSignpostingProperties";
import { StringUtil } from "@lib/titan2/dist/util/string/StringUtil";
import { Point } from "pixi.js";
import { GameFontMap } from "../font/GameFontMap";
import { ArcadeWheelLandscapeProperties } from "../view/properties/landscape/ArcadeWheelLandscapeProperties";
import { AvailableWinDisplayLandscapeProperties } from "../view/properties/landscape/AvailableWinDisplayLandscapeProperties";
import { BackgroundLandscapeProperties } from "../view/properties/landscape/BackgroundLandscapeProperties";
import { BigWinLandscapeProperties } from "../view/properties/landscape/BigWinLandscapeProperties";
import { ControlPanelLandscapeProperties, OptionsLandscapeProperties } from "../view/properties/landscape/ControlPanelLandscapeProperties";
import { DemoPlayLandscapeProperties } from "../view/properties/landscape/DemoPlayLandscapeProperties";
import { DialogManagerLandscapeProperties } from "../view/properties/landscape/DialogManagerLandscapeProperties";
import { BaseGameCameraRigLandscapeProperties, ChanceGameBackgroundCameraRigLandscapeProperties, ChanceGameForegroundCameraRigLandscapeProperties } from "../view/properties/landscape/FeatureCameraRigLandscapeProperties";
import { FeatureNotepadLandscapeProperties } from "../view/properties/landscape/FeatureNotepadLandscapeProperties";
import { FreeSpinsOverlayLandscapeProperties } from "../view/properties/landscape/FreeSpinsOverlayLandscapeProperties";
import { FullHouseLandscapeProperties } from "../view/properties/landscape/FullHouseLandscapeProperties";
import { LoaderLandscapeProperties, PreloaderLandscapeProperties } from "../view/properties/landscape/LoaderLandscapeProperties";
import { MessageBarLandscapeProperties } from "../view/properties/landscape/MessageBarLandscapeProperties";
import { NavigationLandscapeProperties } from "../view/properties/landscape/NavigationLandscapeProperties";
import { PayTableLandscapeProperties } from "../view/properties/landscape/PayTableLandscapeProperties";
import { ReelsLandscapeProperties } from "../view/properties/landscape/ReelsLandscapeProperties";
import { ReelWildParticlesLandscapeProperties } from "../view/properties/landscape/ReelWildParticlesLandscapeProperties";
import { ScatterPickBackgroundLandscapeProperties } from "../view/properties/landscape/ScatterPickBackgroundLandscapeProperties";
import { ScatterPickCoconutLandscapeProperties } from "../view/properties/landscape/ScatterPickCoconutLandscapeProperties";
import { ScatterWinLandscapeProperties } from "../view/properties/landscape/ScatterWinLandscapeProperties";
import { SlingoAnimationLandscapeProperties } from "../view/properties/landscape/SlingoAnimationLandscapeProperties";
import { SlingoParticlesLandscapeProperties } from "../view/properties/landscape/SlingoParticlesLandscapeProperties";
import { SpinsRemainingLandscapeProperties } from "../view/properties/landscape/SpinsRemainingLandscapeProperties";
import { StakeSelectorLandscapeProperties } from "../view/properties/landscape/StakeSelectorLandscapeProperties";
import { SummaryLandscapeProperties } from "../view/properties/landscape/SummaryLandscapeProperties";
import { TestDisplayLandscapeProperties } from "../view/properties/landscape/TestDisplayLandscapeProperties";
import { TicketLandscapeProperties } from "../view/properties/landscape/TicketLandscapeProperties";
import { TopBarLandscapeProperties } from "../view/properties/landscape/TopBarLandscapeProperties";
import { TotalWinCounterLandscapeProperties } from "../view/properties/landscape/TotalWinCounterLandscapeProperties";
import { WinDisplayLandscapeProperties } from "../view/properties/landscape/WinDisplayLandscapeProperties";
import { WinLineCelebrationLandscapeProperties } from "../view/properties/landscape/WinLineCelebrationLandscapeProperties";
import { WinLineLandscapeProperties } from "../view/properties/landscape/WinLineLandscapeProperties";
import { ArcadeWheelPortraitProperties } from "../view/properties/portrait/ArcadeWheelPortraitProperties";
import { AvailableWinDisplayPortraitProperties } from "../view/properties/portrait/AvailableWinDisplayPortraitProperties";
import { BackgroundPortraitProperties } from "../view/properties/portrait/BackgroundPortraitProperties";
import { BigWinPortraitProperties } from "../view/properties/portrait/BigWinPortraitProperties";
import { ControlPanelPortraitProperties, OptionsPortraitProperties } from "../view/properties/portrait/ControlPanelPortraitProperties";
import { DialogManagerPortraitProperties } from "../view/properties/portrait/DialogManagerPortraitProperties";
import { BaseGameCameraRigPortraitProperties, ChanceGameBackgroundCameraRigPortraitProperties, ChanceGameForegroundCameraRigPortraitProperties } from "../view/properties/portrait/FeatureCameraRigPortraitProperties";
import { FeatureNotepadPortraitProperties } from "../view/properties/portrait/FeatureNotepadPortraitProperties";
import { FreeSpinsOverlayPortraitProperties } from "../view/properties/portrait/FreeSpinsOverlayPortraitProperties";
import { FullHousePortraitProperties } from "../view/properties/portrait/FullHousePortraitProperties";
import { LoaderPortraitProperties, PreloaderPortraitProperties } from "../view/properties/portrait/LoaderPortraitProperties";
import { MessageBarPortraitProperties } from "../view/properties/portrait/MessageBarPortraitProperties";
import { MiniPayTablePortraitProperties } from "../view/properties/portrait/MiniPayTablePortraitProperties";
import { NavigationPortraitProperties } from "../view/properties/portrait/NavigationPortraitProperties";
import { PayTablePortraitProperties } from "../view/properties/portrait/PayTablePortraitProperties";
import { ReelsPortraitProperties } from "../view/properties/portrait/ReelsPortraitProperties";
import { ReelWildParticlesPortraitProperties } from "../view/properties/portrait/ReelWildParticlesPortraitProperties";
import { ScatterPickBackgroundPortraitProperties } from "../view/properties/portrait/ScatterPickBackgroundPortraitProperties";
import { ScatterPickCoconutPortraitProperties } from "../view/properties/portrait/ScatterPickCoconutPortraitProperties";
import { ScatterWinPortraitProperties } from "../view/properties/portrait/ScatterWinPortraitProperties";
import { SlingoAnimationPortraitProperties } from "../view/properties/portrait/SlingoAnimationPortraitProperties";
import { SlingoParticlesPortraitProperties } from "../view/properties/portrait/SlingoParticlesPortraitProperties";
import { SpinsRemainingPortraitProperties } from "../view/properties/portrait/SpinsRemainingPortraitProperties";
import { StakeSelectorPortraitProperties } from "../view/properties/portrait/StakeSelectorPortraitProperties";
import { SummaryPortraitProperties } from "../view/properties/portrait/SummaryPortraitProperties";
import { TestDisplayPortraitProperties } from "../view/properties/portrait/TestDisplayPortraitProperties";
import { TicketPortraitProperties } from "../view/properties/portrait/TicketPortraitProperties";
import { TopBarPortraitProperties } from "../view/properties/portrait/TopBarPortraitProperties";
import { TotalWinCounterPortraitProperties } from "../view/properties/portrait/TotalWinCounterPortraitProperties";
import { WinDisplayPortraitProperties } from "../view/properties/portrait/WinDisplayPortraitProperties";
import { WinLineCelebrationPortraitProperties } from "../view/properties/portrait/WinLineCelebrationPortraitProperties";
import { WinLinePortraitProperties } from "../view/properties/portrait/WinLinePortraitProperties";
/**
 * Factory.ts
 */
export class Factory {
    constructor() {
        this.createFontMap();
        this.createModel();
    }
    createMainCameraRig() {
        return new MainCameraRig(this);
    }
    createScatterPickBackground() {
        return new GameScatterPickBackground(this, new ScatterPickBackgroundLandscapeProperties(), new ScatterPickBackgroundPortraitProperties());
    }
    createScatterPickCoconut() {
        return new GameScatterPickCoconut(this, new ScatterPickCoconutLandscapeProperties(), new ScatterPickCoconutPortraitProperties());
    }
    createBaseGameCameraRig() {
        return new FeatureCameraRig(this, new BaseGameCameraRigLandscapeProperties(), new BaseGameCameraRigPortraitProperties());
    }
    createChanceGameBackgroundCameraRig() {
        return new FeatureCameraRig(this, new ChanceGameBackgroundCameraRigLandscapeProperties(), new ChanceGameBackgroundCameraRigPortraitProperties());
    }
    createChanceGameForegroundCameraRig() {
        return new FeatureCameraRig(this, new ChanceGameForegroundCameraRigLandscapeProperties(), new ChanceGameForegroundCameraRigPortraitProperties());
    }
    createMiniPayTable() {
        return new GameMiniPayTable(this, new MiniPayTablePortraitProperties());
    }
    createPayTableManager() {
        return new PayTableManager(this);
    }
    createFontMap() {
        return new GameFontMap();
    }
    createModel() {
        this.model = new GameModel();
        this.model.setBigWinThreshold(20, 0);
        this.model.setBigWinThreshold(50, 1);
        this.model.setBigWinThreshold(100, 2);
        this.model.setAutoDabInterval(500);
        this.model.setCompleteInterval(0);
        this.model.setUsePurchaseSpinTotal(true);
        this.model.setCollectAvailable(true);
        this.model.setBonusBalanceEnabled(true);
        this.model.setAutoSpin(true);
        this.model.setPriceThreshold(10);
        this.model.addOption(ResponsibleGamingOptionType.EXTRA_SPIN, [0, 2, 4, 6, 8]);
        this.model.addOption(ResponsibleGamingOptionType.SPIN_PRICE, [1, 2, 5, 10, 25]);
        this.model.addOption(ResponsibleGamingOptionType.SINGLE_GAME_STAKE, [2, 5, 10, 20, 50]);
        this.model.addOption(ResponsibleGamingOptionType.MAXIMUM_LOSS, [10, 20, 30, 40, 50]);
    }
    createPreloader() {
        return new Preloader(this, new PreloaderLandscapeProperties(), new PreloaderPortraitProperties());
    }
    createLoader() {
        return new GameLoaderDialog(new LoaderLandscapeProperties(), new LoaderPortraitProperties(), AppData.RELEASE_VERSION);
    }
    createOrientation() {
        return null;
    }
    createGame() {
        return new Game(this);
    }
    createTotalWinCounter() {
        return new GameTotalWinCounter(this, new TotalWinCounterLandscapeProperties(), new TotalWinCounterPortraitProperties());
    }
    createMain() {
        return new Main(this);
    }
    createBigWin() {
        return new GameBigWin(this, new BigWinLandscapeProperties(), new BigWinPortraitProperties());
    }
    createFullHouse() {
        return new GameFullHouse(this, new FullHouseLandscapeProperties(), new FullHousePortraitProperties());
    }
    createScatterWin() {
        return new GameScatterWin(this, new ScatterWinLandscapeProperties(), new ScatterWinPortraitProperties());
    }
    createWinLineCelebration() {
        return new GameWinLineCelebration(this, new WinLineCelebrationLandscapeProperties(), new WinLineCelebrationPortraitProperties());
    }
    createWinLine() {
        return new GameWinLine(this, new WinLineLandscapeProperties(), new WinLinePortraitProperties());
    }
    createReel() {
        return new GameReel(this, new GameReelProperties());
    }
    createReels() {
        return new GameReels(this, new ReelsLandscapeProperties(), new ReelsPortraitProperties());
    }
    createTicket() {
        return new GameTicket(this, new TicketLandscapeProperties(), new TicketPortraitProperties());
    }
    createTicketSymbol() {
        return new GameTicketSymbol(this, new GameTicketSymbolProperties());
    }
    createControlPanel() {
        return new GameControlPanel(this, new ControlPanelLandscapeProperties(), new ControlPanelPortraitProperties());
    }
    createSlingoParticles() {
        return new GameSlingoParticles(this, new SlingoParticlesLandscapeProperties(), new SlingoParticlesPortraitProperties());
    }
    createReelWildParticles() {
        return new GameReelWildParticles(this, new ReelWildParticlesLandscapeProperties(), new ReelWildParticlesPortraitProperties());
    }
    createOptions() {
        return new Options(this, new OptionsLandscapeProperties(), new OptionsPortraitProperties());
    }
    createArcadeWheel() {
        return new ArcadeWheel(this, new ArcadeWheelLandscapeProperties(), new ArcadeWheelPortraitProperties());
    }
    createStakeSelector() {
        return new GameStakeSelector(new StakeSelectorLandscapeProperties(), new StakeSelectorPortraitProperties());
    }
    createSpinsRemaining() {
        return new GameSpinsRemaining(this, new SpinsRemainingLandscapeProperties(), new SpinsRemainingPortraitProperties());
    }
    createBackground() {
        return null;
    }
    createGameBackground() {
        return new GameBackground(this, new BackgroundLandscapeProperties(), new BackgroundPortraitProperties());
    }
    createPayTable() {
        return new GamePayTable(this, new PayTableLandscapeProperties(), new PayTablePortraitProperties());
    }
    createPayTableCell() {
        return null;
    }
    createPortraitPayTable() {
        return new GameMiniPayTable(this, new MiniPayTablePortraitProperties());
    }
    createWinDisplay() {
        return new GameWinDisplay(this, new WinDisplayLandscapeProperties(), new WinDisplayPortraitProperties());
    }
    createAvailableWinDisplay() {
        return new GameAvailableWinDisplay(this, new AvailableWinDisplayLandscapeProperties(), new AvailableWinDisplayPortraitProperties());
    }
    createFeatureNotepad() {
        return new GameFeatureNotepad(this, new FeatureNotepadLandscapeProperties(), new FeatureNotepadPortraitProperties());
    }
    createChanceGameNote() {
        return new GameScatterWinNote(this, new GameScatterWinNoteProperties());
    }
    createWinLineNote() {
        return new GameWinLineNote(this, new GameWinLineNoteProperties());
    }
    createNavigation() {
        return new Navigation(this, new NavigationLandscapeProperties(), new NavigationPortraitProperties());
    }
    createTopBar() {
        return new GameTopBar(this, new TopBarLandscapeProperties(), new TopBarPortraitProperties());
    }
    createMessageBar() {
        return new GameMessageBar(this, new MessageBarLandscapeProperties(), new MessageBarPortraitProperties());
    }
    createMessageBarData() {
        return new GameMessageBarData();
    }
    createTestDisplay() {
        return new GameTest(this, new TestDisplayLandscapeProperties(), new TestDisplayPortraitProperties());
    }
    createSlingoAnimation() {
        return new SlingoAnimationSpine(this, new SlingoAnimationLandscapeProperties(), new SlingoAnimationPortraitProperties());
    }
    createSummary() {
        return new GameSummary(this, new SummaryLandscapeProperties(), new SummaryPortraitProperties());
    }
    createSummaryCell(properties) {
        return new GameSummaryCell(this, properties);
    }
    createDemoPlay() {
        return new DemoPlay(new DemoPlayLandscapeProperties());
    }
    createFireworkBurst() {
        return new GameFireworkBurst(this, new GameFireworkBurstProperties());
    }
    getDialogManager() {
        if (!this.dialogManager) {
            this.dialogManager = new GameDialogManager(new DialogManagerLandscapeProperties(), new DialogManagerPortraitProperties());
        }
        return this.dialogManager;
    }
    getModel() {
        return this.model;
    }
    createDialogController() {
        return new GameDialogController(this);
    }
    createOrientationController() {
        return new OrientationController(this);
    }
    createControllers() {
        const controllers = [
            new GameAppController(this),
            new GameController(this),
            new SettingsController(this),
            new GameSoundController(this),
            new GameScatterSoundController(this),
            new GameReelController(this),
            new GameScatterPickController(this),
        ];
        return controllers;
    }
    getOperatorConfig() {
        return this.wrapperConfig.getOperatorConfig();
    }
    setWrapperConfig(config) {
        this.wrapperConfig = config;
        if (this.wrapperConfig) {
            this.model.setGameId(this.wrapperConfig.getOperatorParameters().getGameId());
        }
    }
    getWrapperConfig() {
        return this.wrapperConfig;
    }
    getConfigPath() {
        return AppData.VERSION + "/xml/game/Config.xml";
    }
    getLandscapeTileLocation() {
        return "";
    }
    getPortraitTileLocation() {
        return "";
    }
    getLandscapeViewport() {
        return new Viewport(1946, 1946, 1024, 1024, OrientationType.LANDSCAPE);
    }
    getPortraitViewport() {
        return new Viewport(1024, 1024, 1946, 1946, OrientationType.PORTRAIT);
    }
    createGameConfig() {
        return new GameConfig();
    }
    createGameHistory() {
        if (this.hasInGameReplay()) {
            return undefined;
        }
        return new DetailedGameHistory(this, new DetailedGameHistoryPropertiesLandscape(), new DetailedGameHistoryPropertiesPortrait());
    }
    getGameConfig() {
        return new GameConfig();
    }
    setGameConfig(gameConfig) { }
    createFreeSpinsOverlay() {
        return new GameFreeSpinsOverlay(this, new FreeSpinsOverlayLandscapeProperties(), new FreeSpinsOverlayPortraitProperties());
    }
    createSignPosting() {
        return new SGDSignposting("Fruity Fortune 94", new SGDSignpostingLandscapeProperties(), new SGDSignpostingPortraitProperties());
    }
    getFreeRoundsUIProperties() {
        return new AbstractFreeRoundsInfoBannerProperties(new Point(), FreeRoundsInfoBannerLocation.BOTTOM);
    }
    hasInGameReplay() {
        return StringUtil.isTrue(this.getWrapperConfig().getGame().getHasReplay());
    }
    hasAccessibleHelp() {
        return false;
    }
    getBackgroundColour() {
        return 0x01052d;
    }
}
//# sourceMappingURL=Factory.js.map